import React from 'react';
import { FileIconBase } from './_base';
const VideoFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#D14B6E", label: "MP4" })));
export default VideoFileIcon;
